module.exports = __webpack_public_path__ + "img/logo.5e25b717.png";